import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from '@/i18n';
import '@/icons/index';

// 函数组件不适用于自动引入s
import 'vant/es/toast/style';
import 'vant/es/dialog/style';

import '@/styles/index.less';

import SvgIcon from '@/components/SvgIcon/index.vue';
// import VConsole from 'vconsole';
// import regSvgCom from '@/icons/index';
import remPlan from '@/utils/rem';

remPlan();

// 开发环境 并且需要 VConsole
// if (process.env.VUE_APP_VCONSOLE && process.env.NODE_ENV !== 'production') {
//     try {
//         // eslint-disable-next-line no-unused-vars
//         const vConsole = new VConsole();
//     } catch (e) {
//         console.log(e);
//     }
// }

Vue.component('SvgIcon', SvgIcon);

Vue.config.productionTip = false;

// eslint-disable-next-line no-unused-vars
const app = new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
});
app.$mount('#app');
console.log('打包时间', process.env.__Vite_Package_Time__);
